<template>
  <fragment>
    <div class="v2_font_Montserrat">
      <!-- <div class="ico-block-label d-inline-flex align-items-center p-1 px-2 mb-2">
        <i class="mdi mdi-account mr-2" aria-hidden="true"/>
        <span class="pl-3 pr-5">Job Offer</span>
      </div> -->
      <div class="font-weight-bold font_size_1125rem v3_color_teal mb-3 border_bottom_1 border_bottom_light_teal">
        Your Job Opportunity 
      </div>
      <div 
      :class="{
        'scroll-section-large-height': this.jobQuestion && this.jobQuestion.talent_type =='JOB_INFORMATION',
        'scroll-section-height': this.jobQuestion && this.jobQuestion.talent_type !== 'JOB_INFORMATION'
      }"
      class="scroll-job-opp result-box-border"
      >
        <div v-if="jobOffer && jobOffer.title" class="text-center d-flex flex-column align-items-center mt-2">
          <div class="font_size_1125rem font-weight-bold v3_color_teal">
            Title
          </div>
          <div class="font_size_1000rem font-weight-normal">
            {{ jobOffer.title }}
          </div>
        </div>
        <div v-if="specialtyName || subspecialtyName" class="text-center d-flex flex-column align-items-center mt-2">
          <template v-if="specialtyName">
            <div class="font_size_1125rem font-weight-bold v3_color_teal">
              Specialty
            </div>
            <div class="font_size_1000rem font-weight-normal">
              {{ specialtyName }}
            </div>
          </template>
          <template v-if="subspecialtyName">
            <div class="font_size_1125rem font-weight-bold mt-2 v3_color_teal">
              Subspecialty
            </div>
            <div class="font_size_1000rem font-weight-normal">
              {{ subspecialtyName }}
            </div>
          </template>
        </div>
        <!-- <div v-if="jobOffer && jobOffer.location_zip_code" class="job-question p-3 mb-2">
          <div class="font_size_1125rem font-weight-bold v3_color_teal">
            Location
          </div>
          <div class="font_size_1000rem font-weight-normal">
            {{ jobOffer.location_zip_code }}
          </div>
        </div> -->
        <div
            v-for="componentData in componentsData"
            :key="componentData.key"
            class="text-center d-flex flex-column align-items-center mt-2"
        >
          <component
              :is="componentData.name"
              :box-class="' '"
              :header-class="'font_size_1125rem font-weight-bold '"
              :value-class="'font_size_1000rem font-weight-normal'"
              v-bind="componentData.props"
          />
        </div>
      </div>
    </div>
  </fragment>
</template>

<script>
import { getJobQuestionResponseValues } from '@/helpers/jobQuestionsHelper';
import { JOB_QUESTION_TYPES } from '@/store';
import GetSpecialtyOptionsMixin from '@/mixins/GetSpecialtyOptionsMixin';
import GetSubspecialtyOptionsMixin from '@/mixins/GetSubspecialtyOptionsMixin';
import RecruiterIcoCriteriaResultJobQuestion from '@/components/recruiter/ico/criteria/result/RecruiterIcoCriteriaResultJobQuestion';

export default {
  name: 'JobOfferValues',
  mixins: [GetSpecialtyOptionsMixin, GetSubspecialtyOptionsMixin],
  components: {
    RecruiterIcoCriteriaResultJobQuestion,
  },
  props: {
    jobQuestions: Array,
    jobOffer: Object,
    jobQuestion:Object
  },
  created:function(){
    
  },
  computed: {
    specialty: function () {
      if (!this.jobOffer || !this.jobOffer.specialty_id) return null;
      return (
        this.$store.state.specialtyOptions.find(
          (s) => s.value === this.jobOffer.specialty_id
        ) || {}
      ).specialty;
    },
    specialtyName: function () {
      return (this.specialty || {}).title;
    },
    subspecialty: function () {
      if (!this.jobOffer || !this.jobOffer.subspecialty_id) return null;
      return (
        this.$store.state.subspecialtyOptions.find(
          (s) => s.value === this.jobOffer.subspecialty_id
        ) || {}
      ).subspecialty;
    },
    subspecialtyName: function () {
      return (this.subspecialty || {}).title;
    },
    realJobQuestions: function () {
      return this.jobQuestions.filter(
        ({ talent_type }) =>
          talent_type !== JOB_QUESTION_TYPES.SPECIALTY &&
          talent_type !== JOB_QUESTION_TYPES.JOB_INFORMATION
      );
    },
    componentsData: function () {
      return this.realJobQuestions.reduce((data, item) => {
        if (
          !item.value ||
          (!Object.keys(item.value).length &&
            (!Array.isArray(item.value) || !item.value.length))
        )
          return data;
        data.push({
          name: RecruiterIcoCriteriaResultJobQuestion.name,
          key: item.id,
          props: {
            jobQuestion: item,
          },
          isVisible: true
        });
        return data;
      }, []);
    },
  },
  methods: {
    getResponseValues: function (jobQuestion) {
      return getJobQuestionResponseValues(jobQuestion);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../../../sass/variables_mixins.scss';
.ico-block-label {
  background: $phairify_v2_color_primary_teal 0 0 no-repeat padding-box;
  border-radius: 8px;
  text-align: center;
  font: normal normal 600 16px/20px;
  font-family: $phairify_font_montserrat;
  line-height: 25px;
  letter-spacing: 0;
  color: $phairify_v2_color_white;
  opacity: 1;
  .mdi.mdi-account {
    font-size: 22px;
  }
}
.job-question {
  background: #FFFFFF 0 0 no-repeat padding-box;
  border: 1px solid #000000;
  border-radius: 0;
  opacity: 1;
  min-height: 70px;
  text-align: center;
  font: normal normal 600 20px/25px;
  letter-spacing: 0;
  color: black;
  font-family: $phairify_font_montserrat;
  .job-question-label {
    font: normal normal 600 20px/25px;
  }
  .job-question-answer {
    font: normal normal normal 20px/25px;
  }
  &.selected {
    color: $phairify_v2_color_white;
    background-color: $phairify_v2_color_primary_teal;
  }
}
.scroll-job-opp{
  overflow-y: scroll;
  display: flex;
  flex-flow: column;
  width: 100%;
}
.scroll-section-height{
  height:350px;
}
.scroll-section-large-height{
  height:680px;
}
.result-box-border {
	border: 1px solid #000000;
}
@media screen and (max-width: 768px) {
  .scroll-section-large-height{
    height:350px !important;
  }
}

@media screen and (max-width: 1400px) {
  .scroll-job-opp{
    overflow-y: auto !important;
  }
  .scroll-section-large-height{
    height:unset !important;
  }
  .scroll-section-height{
    height:unset !important;
  }
}
</style>
